import React from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableHead, 
    TableRow, Button, IconButton, Typography, 
    Card, CardHeader, CardContent
} from '@mui/material';
import { FaPlus, FaEdit, FaWrench } from 'react-icons/fa';

const ContactTopicManagement = ({ 
    topics, 
    onAdd, 
    onEdit, 
    onDelete 
}) => {
    return (
        <Card elevation={1} sx={{ mb: 4, borderRadius: 2, overflow: 'hidden' }}>
            <CardHeader 
                title={
                    <Typography variant="subtitle1" fontWeight="bold">Kontakt-Themen</Typography>
                }
                action={
                    <Button 
                        variant="contained" 
                        size="small" 
                        startIcon={<FaPlus />} 
                        onClick={onAdd}
                        sx={{ bgcolor: 'error.main', '&:hover': { bgcolor: 'error.dark' } }}
                    >
                        Neu
                    </Button>
                }
                sx={{ bgcolor: 'white', borderBottom: '1px solid #f0f0f0' }}
            />
            <CardContent sx={{ p: 0 }}>
                <TableContainer>
                    <Table size="small">
                        <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>LABEL</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem', display: { xs: 'none', md: 'table-cell' } }}>E-MAIL ZIEL</TableCell>
                                <TableCell align="center" sx={{ width: '1%', fontWeight: 'bold', fontSize: '0.75rem' }}><FaWrench /></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {topics.map(t => (
                                <TableRow key={t._id} hover>
                                    <TableCell>
                                        <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>{t.label}</Typography>
                                    </TableCell>
                                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                            {t.recipientEmail}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton size="small" color="primary" onClick={() => onEdit(t)}>
                                            <FaEdit fontSize="0.9rem" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};

export default ContactTopicManagement;
